"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgUndo(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M11.864 0C16.357 0 20 3.582 20 8s-3.643 8-8.136 8a8.149 8.149 0 01-4.959-1.677l-.253-.201 1.44-1.416A6.123 6.123 0 0011.864 14c3.365 0 6.102-2.692 6.102-6 0-3.309-2.737-6-6.102-6-1.493 0-2.877.508-3.918 1.414l-.238.214c-.16.146-.313.29-.405.377L9 5.032 4 8V2l1.579.961.54-.598c.04-.043.07-.074.083-.086A8.151 8.151 0 0111.864 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Undo')(SvgUndo);
//# sourceMappingURL=Undo.js.map